module.exports = __webpack_public_path__ + "media/site/images/products/omms-screen-ad0320e982580fe9704f747b7901aee9.png";